import React, { useState, useEffect } from 'react';
import { Search, Close } from '../../assets/icons';
import PropTypes from 'prop-types';
import { Button, Input } from '../shared';
import { BUTTON } from '../../constants';

export const SearchBar = ({ search, setSearch, searchTerm, setSearchTerm, onDefaultSearch, inline = false }) => {
  const [lastSearchedTerm, setLastSearchedTerm] = useState(searchTerm || ''); // Initialize with current searchTerm
  const [searchTriggered, setSearchTriggered] = useState(false);
  const [isSearchPerformed, setIsSearchPerformed] = useState(!!searchTerm); // If searchTerm exists, mark as already performed

  // Initial search state already comes from searchTerm. Searching later remains
  // an explicit button/Enter action, not a side effect of typing.

  // Trigger the default API call when searchTerm is cleared and a search was performed
  useEffect(() => {
    if (searchTerm === '' && isSearchPerformed) {
      setSearch(false);
      setLastSearchedTerm('');
      setIsSearchPerformed(false);
      onDefaultSearch();
    }
  }, [searchTerm, isSearchPerformed, setSearch, onDefaultSearch]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setSearchTriggered(false);
  };

  const searchHandler = () => {
    const trimmed = searchTerm.trim();
    setSearchTerm(trimmed);
    setSearch(false);
    setTimeout(() => {
      setSearch(true);
      setLastSearchedTerm(trimmed);
      setSearchTriggered(true);
      setIsSearchPerformed(true);
    }, 0);
  };

  const clearSearch = () => {
    setSearchTerm('');
  };

  const isSearchDisabled =
    !searchTerm ||
    searchTerm?.trim()?.length === 0 ||
    searchTerm === lastSearchedTerm ||
    (searchTriggered && search);

  // Handle Enter key press
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !isSearchDisabled) {
      searchHandler();
    }
  };

  const searchContent = (
      <div className="container-search-bar w-100 d-flex align-items-center gap-2">
        <div className="bg-white position-relative d-flex align-items-center w-100 justify-content-start searchbar-area">
          <div className="search-btn2 position-absolute border-0">
            <Search />
          </div>
          <Input
            type="text"
            className="border-0 w-100 d-flex align-items-center justify-content-center"
            placeholder={'Search...'}
            value={searchTerm}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
          />
          {searchTerm && (
            <div
              onClick={clearSearch}
              className="search-btn2 border-0"
              role="button"
              aria-label="Clear search">
              <Close />
            </div>
          )}
        </div>
        <Button
          clickHandler={searchHandler}
          className={`search-btn d-flex align-items-center justify-content-center px-3 ${isSearchDisabled ? 'disabled' : ''}`}
          disabled={isSearchDisabled}
        >
          {BUTTON.SEARCH}
        </Button>

      </div>
  );
  
  return inline ? searchContent : <div className="mb-3">{searchContent}</div>;
};

SearchBar.propTypes = {
  search: PropTypes.bool.isRequired,
  setSearch: PropTypes.func.isRequired,
  searchTerm: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  onDefaultSearch: PropTypes.func.isRequired,
};
